<template>
  <div class="events-container">
    <EventMonthContainer v-if="listViewType === 'month'" />
    <EventAllContainer v-else />
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, onMounted } from 'vue';
import { useStore } from 'vuex';
import isEmpty from 'lodash/isEmpty';

defineOptions({
  name: 'EventsListView',
});

const EventAllContainer = defineAsyncComponent(() => import('./List/EventAllContainer.vue'));
const EventMonthContainer = defineAsyncComponent(() => import('./List/EventMonthContainer.vue'));

const store = useStore();

const listViewType = computed(() => store.state.events.listViewType);
const sections = computed(() => store.state.events.sections);
const selectedCalendars = computed(() => store.state.events.selectedCalendars);

onMounted(() => {
  if (isEmpty(selectedCalendars.value)) {
    store.commit(
      'events/initSelectedCalendars',
      sections.value.flatMap((item) => item.id),
    );
  }
});
</script>
